var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStylus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40018_36604",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40018_36604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.78413 14.0029C2.55079 14.0584 2.34802 14.0001 2.17579 13.8279C2.00357 13.6556 1.94524 13.4529 2.00079 13.2195L2.66746 10.0362L5.96746 13.3362L2.78413 14.0029ZM5.96746 13.3362L2.66746 10.0362L10.3008 2.40286C10.5563 2.14731 10.873 2.01953 11.2508 2.01953C11.6286 2.01953 11.9452 2.14731 12.2008 2.40286L13.6008 3.80286C13.8563 4.05842 13.9841 4.37509 13.9841 4.75286C13.9841 5.13064 13.8563 5.44731 13.6008 5.70286L5.96746 13.3362ZM11.2508 3.3362L4.35079 10.2362L5.76746 11.6529L12.6675 4.75286L11.2508 3.3362Z",
    fill: "#049981"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStylus);
export default __webpack_public_path__ + "static/media/stylus.e82cbd791a04d9bcdb449331b512e588.svg";
export { ForwardRef as ReactComponent };